module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4g7Lm"))).then(() => parcelRequire('37nVf'));